import styled from 'styled-components';

export const Container = styled.button`
  all: unset;

  position: relative;

  cursor: pointer;
  width: 7.5rem;
  display: inline-block;
  position: relative;

  margin-bottom: 2rem;
`;

export const FileInput = styled.input`
  display: none;
`;
